import { Dialog, useTooltipSeries } from '../'
import { Body, Box, Button, H4 } from '../'
import { assetUrl } from '../../../utilities.js'
import './TooltipDialog.scss'

export const TooltipDialog = ({ order, title, image, text, secondText, onClick, buttonText, onAltClick, altSkip, children, ...props }) => {
  const { next, skip, tip, register, active } = useTooltipSeries()
  register?.(order)

  const handleClick = () => {
    if(onClick) {
      onClick()
    }
    if(order === tip) {
      next()
    }
  }

  const handleAltClick = () => {
    if(onAltClick) {
      onAltClick()
    }
    if(altSkip) {
      skip()
    } else {
      next()
    }
  }

  return (
    <>
      {(tip === order && active) && <Box
        zIndex={99}
        position="absolute"
        top={0}
        left={0}
        fullHeight
        fullWidth
      />}
      <Dialog {...props} open={tip === order && active} showControls={false} mobileDrawer mobileBackground="white" closeButton={false}>
        <Box fullWidth>
          <img width="100%" src={assetUrl(`tutorials/${image}.png`)} alt={image} />
        </Box>
        <Box gap={16} column>
          <H4 color="black">{title}</H4>
          <Body color="black" align="center">{text}</Body>
          {secondText && <Body color="black" align="center">{secondText}</Body>}
          {children}
        </Box>
        <Box className="tutorial-dialog-buttons">
          {onAltClick && (
            <Button light fullWidth onClick={handleAltClick}>
              Not today
            </Button>
          )}
          <Button fullWidth onClick={handleClick}>
            {buttonText}
          </Button>
        </Box>
      </Dialog>
    </>
  )
}